define(function(require, exports, module) {
    'use strict';
    var BaseModel = require('common/base.model');
    var userValidationConfig = require('modules/user/user.validation.config');
    var _ = require('underscore');

    module.exports = BaseModel.extend({

        getData: function(data) {
            data = this._parseAddress(data);

            return data;
        },

        getValidationConfig: function() {
            return userValidationConfig();
        },

        /**
         * Get proper address field
         * @param  {Object} data
         * @return {Object}
         */
        _parseAddress: function(data) {
            var result = _.omit(data, 'address', 'address2', 'address3', 'address4');

            if (data.address) {
                result.address = [data.address3, data.address, data.address2].filter(Boolean).join(' ');
            }

            return result;
        }
    });
});
